/**
 * ============================================================
 * PLACEHOLDER PROSE — TURN THIS OFF BEFORE THE SITE GOES PUBLIC
 * ============================================================
 *
 * Case-study sections that have no real content yet render Latin lorem ipsum in
 * production builds, so the deployed pages have their full article length while
 * the real copy is written.
 *
 * Latin, deliberately. Plausible English filler about safety research or
 * laboratory teaching would read as fact — a recruiter could not tell it from
 * Mafazi's real record, and he could be questioned on it. Latin is unmistakably
 * unwritten to any reader.
 *
 * To go live for real: set PLACEHOLDER_PROSE to false. Sections still lacking
 * paragraphs then drop out of production entirely, exactly as they did before.
 * `bun run build` prints a warning for as long as this stays true.
 */
export const PLACEHOLDER_PROSE = true;

const LOREM = [
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
  "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.",
];

/**
 * Two paragraphs, varied by heading so every unwritten section does not read
 * identically. Deterministic — no randomness, so builds stay reproducible.
 */
export function placeholderParagraphs(heading: string): string[] {
  let seed = 0;
  for (let i = 0; i < heading.length; i++) seed = (seed + heading.charCodeAt(i)) % LOREM.length;
  return [LOREM[seed]!, LOREM[(seed + 1) % LOREM.length]!];
}
